import React from 'react';
import { Helmet } from 'react-helmet-async';
import { CONFIG } from 'shared/config';
import { ICON } from 'shared/constants/ASSETS_URL';
interface Props {
  title: string;
  description: string;
  name: string;
  type: string;
}

const SEO: React.FC<Props> = ({ title, description, name, type }) => {
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* End standard metadata tags */}
      {/* Facebook tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={'Casting App - Jobs'} />
      <meta property="og:image" content={`${CONFIG.JOBS_APP_URL}/favicon.ico`} />

      {/* End Facebook tags */}
      {/* Twitter tags */}
      <meta name="twitter:creator" content={name} />
      <meta name="twitter:card" content={type} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {/* End Twitter tags */}
    </Helmet>
  );
};

export default SEO;
